import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchShippingFees } from "../actions/ShippingFeesActions";
import "../styles/shippingfees.css";
import { ShippingFeesSkeleton } from "./HomeSkeletons";
import formatMoney from "./formatMoney";

function ShippingFees() {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.shippingFees);
  const { items } = useSelector((state) => state.cart);
  const [totalWeight, setTotalWeight] = useState(0);

  useEffect(() => {
    dispatch(fetchShippingFees());
  }, [dispatch]);

  useEffect(() => {
    if (items && items.length > 0) {
      const weight = items.reduce((total, item) => {
        const itemWeight = item.product?.weight || 0;
        return total + (itemWeight * item.quantity || 0);
      }, 0);
      setTotalWeight(weight);
    } else {
      setTotalWeight(0);
    }
  }, [items]);

  return (
    <div className="shipping-fees">
      <div className="checkout-header">
        <h2 className="checkout-heading">Delivery Fees</h2>
      </div>
      {/* <p>
        Shipping fees are calculated based on the total weight of the products
        in your cart.
      </p> */}

      {loading ? (
        <ShippingFeesSkeleton />
      ) : error ? (
        <p className="error">Error: {error}</p>
      ) : (
        <>
          <p>
            Total weight of products:{" "}
            <span className="amount">
              <strong>{parseFloat(totalWeight).toFixed(0)} g</strong>
            </span>
          </p>
          {totalWeight > 0 ? (
            <p>
              Shipping Fee: <span className="amount-total">Free shipping</span>
            </p>
          ) : (
            <p>Add products to your cart to see delivery details.</p>
          )}
        </>
      )}

      <p>
        In Kigali City:{" "}
        <span className="amount">
          <strong>{formatMoney(parseFloat(2000))}</strong>
        </span>
      </p>
    </div>
  );
}
export default ShippingFees;
